import { ParentEnvironment } from '@dice/app/types/env.type';
import { NgxLoggerLevel } from 'ngx-logger';

function getHost(): string {
  if (localStorage.getItem('use-internal-api-gateway') === 'true') {
    return 'dice-api-gateway-int.scapp-corp.swisscom.com/';
  }
  return 'dice-api-gateway-int.scapp.swisscom.com/';
}

const host = getHost();
const https = 'https://';
const wss = 'wss://';

export const INT_ENV_CONFIG: ParentEnvironment = {
  name: 'sc-int',
  publicStates: ['login'],
  apiEndpoint: `${https + host}`,
  wsEndpoint: `${wss + host}`,
  wsEndpointForUCCP: `${wss + host}`,
  agentViewEndpoint: `agent-view/`,
  anomalyEndpoint: `dice-anomalies/api/anomalies/`,
  auditingEndpoint: `auditing/`,
  budaConfigurationEndpoint: `buda-masterdata/`,
  budaStatisticsConsumerEndpoint: 'buda-message-proxy/',
  budaStatisticsConsumerEndpointForUCCP: 'buda-message-proxy-uccp/',
  agentViewStatisticsConsumerEndpoint: `buda-message-proxy-agentview/`,
  agentInfoStatisticsConsumerEndpoint: `buda-message-proxy-agentinfo/`,
  configEndpoint: `dice-config/api/config/`,
  easyArchitectEndpoint: 'https://easy-architect.uccp-integration-staging.icp.corproot.net/',
  datatableBackupEndpoint: 'https://uccp-soe-datatable-backup.uccp-integration-staging.icp.corproot.net/',
  businessInsightsEndpoint: 'https://uccp-soi-business-insights.uccp-integration-staging.icp.corproot.net/',
  callbackAdminEndpoint: `https://callback-admin.uccp-integration-staging.icp.corproot.net/`,
  callbackAnalyticsEndpoint: `https://callback-analytics.uccp-integration-staging.icp.corproot.net/`,
  dataExchangeEndpoint: `data-exchange/`,
  wfmDataEndpoint: `https://wfm-sap-etl.uccp-integration-staging.icp.corproot.net/`,
  diceUiRedirectPage: 'https://dice-ui.scapp-corp.swisscom.com/',
  eimaEndpoint: `eima/`,
  eimaDREndpoint: `eima-dr/`,
  notifications: `${wss + host}notification/push-message-endpoint`,
  octEndpoint: `chat-campaign-tool/`,
  statisticsConsumerEndpoint: `${wss + host}statistics-consumer/websocket`,
  transfertoolAdminURL: 'https://vega.test2.swisscom.ch/omni-transfertool-admin/login',
  userManagementEndpoint: `user-management/`,
  userManualURL: 'https://wiki.swisscom.com/pages/viewpage.action?pageId=617222684',
  logEndpoint: 'https://dice-api-gateway-int.scapp.swisscom.com/dice-splunk-forwarder/ui/log',
  serverLogLevel: NgxLoggerLevel.WARN,
  agentViewManualURL: 'https://wiki.swisscom.com/x/3yHdL',
  budaStatusURL: 'https://buda-pre.swisscom.com/status',
  cxGenesysModifierURL: 'buda-cx-genesys-modifier/',
  apiProviderURL: 'buda-cx-api-provider/',
};
